import { SVGProps } from 'react';
import { InterpolationValue } from 'styled-components';
import { TriageMessageLevel } from '../../schema/hannibal/types.generated';
import { ThemeColours } from '../../styles/ThemeColours';
import IconError from '../icons/IconError.svg';
import IconInfo from '../icons/IconInfo.svg';
import IconTick from '../icons/IconTick.svg';

export const SlimAlertVariants = {
  Success: {
    primary: ThemeColours.positive,
    secondary: ThemeColours.positive50,
    Icon: IconTick,
  },
  Danger: {
    primary: ThemeColours.negative,
    secondary: ThemeColours.negative100,
    Icon: IconError,
  },
  Warning: {
    primary: ThemeColours.warning600,
    secondary: ThemeColours.warning100,
    Icon: IconError,
  },
  Info: {
    primary: ThemeColours.primary,
    secondary: ThemeColours.primary50,
    Icon: IconInfo,
  },
} as const;

export interface Variant {
  primary: InterpolationValue;
  secondary: InterpolationValue;
  Icon: (props: SVGProps<SVGElement>) => JSX.Element;
}

export const triageMessageLevelToAlertVariant = (level: TriageMessageLevel): Variant =>
  level === TriageMessageLevel.Warning ? SlimAlertVariants.Warning : SlimAlertVariants.Info;
